import Greeting from "./Greeting";
import TotalBalanceBox from "./TotalBalanceBox";
import ServicesTabs from "./ServicesTabs";
import RecentActivities from "./RecentActivities";
import SiteFunctions from "./SiteFunctions";
import AnnouncementMessage from "./AnnouncementMessage";

import { useSelector } from "react-redux";
import Promo from "./Promo";
import HelmetMetaData from "../HelmetMetaData";
import PopUpMessage from "./PopUpMessage";
import BeneficiaryTiles from "./BeneficiaryTiles";

const HomePage = () => {
  const userData = useSelector((state) => state.user.user);
  // console.log(userData);
  // console.log(userData);

  return (
    <div className="flex w-full">
      <HelmetMetaData
        title={"Welcome " + userData.username + " To Billzpay"}
        description="What would you like to do today?"
      />

      <div className="no-scrollbar font-geist flex w-full flex-1 flex-col gap-4 overflow-x-hidden px-3 py-7 pt-4 sm:px-8 xl:max-h-screen xl:overflow-y-scroll">
        <div>
          <Greeting name={userData.username} isAgent={userData.reseller} />
          <p className="dark:text-darkGray text-sm">
            Access & manage your account and transactions efficiently.
          </p>
        </div>

        <div>
          {userData.meta_data?.announcement && (
            <AnnouncementMessage msg={userData.meta_data?.announcement} />
          )}
          {userData.meta_data?.pop_up_message &&
            !userData.meta_data?.pop_up_message?.includes("nothing") && (
              <PopUpMessage message={userData.meta_data?.pop_up_message} />
            )}
          <TotalBalanceBox isAgent={userData.reseller} />
          <ServicesTabs />
          <BeneficiaryTiles />

          <Promo />
          <RecentActivities />
        </div>
      </div>

      <div className="dark:border-darkBorder hidden w-[380px] border-l lg:block">
        <SiteFunctions />
      </div>
    </div>
  );
};

export default HomePage;
